import Progress from 'redux-progress';

import { CURRENCY_LIST } from 'modules/mac/duck/actions/currency/types';
import type { MACCurrencyAction, MACCurrencyState } from '../models';

export const initialState = {
  currencyList: Progress.none,
};

export default (
  state: MACCurrencyState = initialState,
  action: MACCurrencyAction,
): MACCurrencyState => {
  if (action.type === CURRENCY_LIST) {
    return {
      ...state,
      currencyList: action.progress,
    };
  }

  return state;
};
